import { api } from './api';

type FeedbackSubmission = {
  product: string;
  productLabel: string;
  category: string;
  description: string;
  attachments?: File[];
};

const feedbackApi = api.injectEndpoints({
  endpoints: (builder) => ({
    submitFeedback: builder.mutation<{ ok: boolean }, FeedbackSubmission>({
      query: ({ attachments, ...fields }) => {
        if (attachments && attachments.length > 0) {
          const formData = new FormData();
          Object.entries(fields).forEach(([key, value]) => {
            formData.append(key, value);
          });
          attachments.forEach((file) => {
            formData.append('attachments', file);
          });
          return {
            url: 'feedback',
            method: 'POST',
            body: formData,
            formData: true,
          };
        }
        return {
          url: 'feedback',
          method: 'POST',
          body: fields,
        };
      },
    }),
  }),
});

export type { FeedbackSubmission };

export const { useSubmitFeedbackMutation } = feedbackApi;

export { feedbackApi };
